module.exports = angular.module('cartographer.plugin.layer.ces', [])

_ = require 'underscore'

module.exports.run $DI (
  crtLayer
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  ces = crtFeatureLayer.createPlaceholder({
    id: "ces"
    name: "CES"
    atlasMapId: "ces"
    defaultMapEngine: "atlas"
  })

  crtLayer.registerPlugin(ces)

  return
